import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Paper,
  List,
  ListItem,
  Typography
} from '@material-ui/core';
import SelectReact from 'react-select';
import {
  TREE_FIELD_TYPE
} from '../../constants/closet';
import '../../assets/stylesheets/Closet.css';
import i18n from '../../i18n';
import CategoryTreeView from './CategoryTreeView';

class ProductFilters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appliedFilters: {}
    }
  }

  selectFilter = (filter, value) => {
    this.setState((prevState) => (
      { appliedFilters: { ...prevState.appliedFilters, [filter.name]: value } }
    ), () => this.passSelectedFilters());
  }

  passSelectedFilters = () => {
    const { appliedFilters } = this.state;
    const { updateSelectedFilters } = this.props;
    return updateSelectedFilters(appliedFilters);
  }

  handleFilterChange = (filter) => {
    return (selected) => {
      if (filter.multi && selected) {
        return this.selectFilter(filter, selected.map(sel => sel.value))
      }
      return this.selectFilter(filter, (selected || {}).value)
    }
  }

  handleClear = () => {
    this.setState({
      appliedFilters: {}
    }, () => this.passSelectedFilters());
  }

  filterValueIsSelected = (filter, value) => {
    const { appliedFilters } = this.state;
    return filter.multi ?
      appliedFilters[filter.name] && appliedFilters[filter.name].includes(value.key)
      : appliedFilters[filter.name] === value.key
  }

  formatFilterSelectOptions = (filter) => {
    return filter.values.map((value) => {
      const label = i18n.t(`closet:${value.value}`)
      return {
        id: value.key,
        label,
        value: value.key,
        selected: this.filterValueIsSelected(filter, value)
      }
    })
  }

  render() {
    const { filters } = this.props;
    const { appliedFilters } = this.state;
    return (
      <Paper>
        <Typography className="titleFilters" variant="h6" noWrap>
          {i18n.t('productListing:filters')}
        </Typography>
        <List>
          {filters.map((filter) => {
            const placeholder = i18n.t(`closet:${filter.name}`)
            const selectOptions = this.formatFilterSelectOptions(filter)

            /**
            * @todo remove the check that ensures array isn't empty here 
            * and in ProductFilters once indices are updated in prod
            */
            if (filter.fieldType === TREE_FIELD_TYPE && 'parent' in filter.values[0]) {
              return (
                <ListItem key={filter.name}>
                  <CategoryTreeView
                    filter={filter}
                    selectFilter={this.selectFilter}
                    appliedFilters={appliedFilters}
                  />
                </ListItem>
              );
            }

            return (
              <ListItem key={filter.name}>
                <SelectReact
                  className='select'
                  placeholder={placeholder}
                  hideSelectedOptions
                  isClearable
                  menuShouldScrollIntoView={false}
                  options={selectOptions}
                  value={selectOptions.filter(
                    option => option.selected === true
                  )}
                  isMulti={filter.multi}
                  onChange={this.handleFilterChange(filter)}
                />
              </ListItem>
            );
          })}
          <Grid item xs={12}>
            <Button className="ssenseButton ssensePrimary" variant="contained" onClick={this.handleClear}>
              {i18n.t('productListing:clearFilters')}
            </Button>
          </Grid>
        </List>
      </Paper>
    )
  }
}

ProductFilters.propTypes = {
  updateSelectedFilters: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default ProductFilters;